import React from "react";
import Box from "components/common/Box";
import Stack from "components/common/Stack";
import Text from "components/common/Text";

/**
 * Figma 8068:148736 etc. — "Contact Service Mini" (link rows: Blog,
 * Market Updates, News & Articles, Help & Support, Log Out).
 */
const ProfileMenuRow = ({ icon, iconSize = 24, label, onClick, danger = false }) => (
  <Box
    component="button"
    type="button"
    onClick={onClick}
    sx={{
      bgcolor: "#fff",
      border: { xs: "0.75px solid #E2E8F0", md: "1px solid #E2E8F0" },
      borderRadius: { xs: "15px", md: "20px" },
      boxShadow: {
        xs: "0px 3px 7.5px rgba(0,0,0,0.02)",
        md: "0px 4px 10px rgba(0,0,0,0.02)",
      },
      px: { xs: "18px", md: 3 },
      py: { xs: "9px", md: 1.5 },
      width: "100%",
      cursor: "pointer",
      display: "block",
      textAlign: "left",
      "&:hover": { borderColor: "#CBD5E1" },
    }}
  >
    <Stack direction="row" alignItems="center" spacing={{ xs: "9px", md: 1.5 }}>
      <Box
        sx={{
          bgcolor: "#F8FAFC",
          borderRadius: { xs: "7.5px", md: "10px" },
          p: { xs: "7.5px", md: 1.25 },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <Box
          component="img"
          src={icon}
          alt=""
          sx={{
            width: { xs: 18, md: iconSize },
            height: { xs: 18, md: iconSize },
          }}
        />
      </Box>
      <Text
        sx={{
          flex: 1,
          fontWeight: 500,
          fontSize: { xs: "15px", md: "20px" },
          color: danger ? "#FF1744" : "#111827",
        }}
      >
        {label}
      </Text>
      <Box
        component="img"
        src="/images/profile-v2/chevron-right.svg"
        alt=""
        sx={{
          width: { xs: 15, md: 20 },
          height: { xs: 15, md: 20 },
          transform: "rotate(-90deg)",
          flexShrink: 0,
        }}
      />
    </Stack>
  </Box>
);

const ProfileMenuList = ({ items = [] }) => (
  <Stack spacing={{ xs: 1.5, md: 1.75 }} sx={{ width: "100%" }}>
    {items.map((item) => (
      <ProfileMenuRow key={item.label} {...item} />
    ))}
  </Stack>
);

export default ProfileMenuList;
